// Module
var code = "<div class=\"accordion-header\" ng-click=\"vm.togglePane()\"><div class=\"accordion-header-container\"><span ng-transclude></span><i class=\"ion ion-chevron-down small\" ng-if=\"!vm.accordionPaneCtrl.open\"></i><i class=\"ion ion-chevron-up small\" ng-if=\"vm.accordionPaneCtrl.open\"></i></div></div>";
// Exports
var _module_exports =code;;
var path = 'app/components/accordion/header/accordion-header.component.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;